'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'circle-6';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0f3';
var svgPathData = 'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm40-336c0-8.8-7.2-16-16-16l-32 0c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l16 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-16 0c-11.7 0-22.6 3.1-32 8.6l0-8.6c0-17.7 14.3-32 32-32l32 0c8.8 0 16-7.2 16-16zM248 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle6 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;